import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';

import {EditorComponent, TINYMCE_SCRIPT_SRC} from "@tinymce/tinymce-angular";

@Component({
  selector: 'sb-system-journal',
  templateUrl: './system-journal.component.html',
  styleUrls: ['./system-journal.component.scss'],
  providers: [
    // Uses the existing 5.10 installation if it exists, otherwise this one.
    { provide: TINYMCE_SCRIPT_SRC, useValue: 'scripts/assets/tinymce/tinymce.min.js' }
  ]
})
export class SystemJournalComponent implements OnInit, AfterViewInit {

  @ViewChild("editor", {static: false})
  editor: EditorComponent;

  constructor() {
  }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
  }
}
